import { useState } from "react";
import { useParams } from "react-router-dom";

export default function ConfirmBooking() {
  const { token } = useParams<{ token: string }>();

  const [form, setForm] = useState({
    nom: "",
    prenom: "",
    fin: "",
    email: "",
    telephone: "",
  });
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/confirm-booking/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || data.error || "Erreur inconnue");

      setStatus("success");
      setMessage(data.message || "Your appointment is confirmed !");
    } catch (err: any) {
      setStatus("error");
      setMessage(err.message || "There was an error confirming your appointment, please contact the clinic");
    }
  }

  return (
    <div className="max-w-lg mx-auto p-8 bg-white shadow-lg rounded-xl mt-10">
      <h1 className="text-2xl font-bold mb-6 text-center">Appointment confirmation</h1>

      {status === "success" ? (
        <p className="text-green-600 font-semibold text-center">{message}</p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Name"
            className="w-full border rounded p-2"
            value={form.prenom}
            onChange={(e) => setForm({ ...form, prenom: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Surname"
            className="w-full border rounded p-2"
            value={form.nom}
            onChange={(e) => setForm({ ...form, nom: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="FIN (if applicable)"
            className="w-full border rounded p-2"
            value={form.fin}
            onChange={(e) => setForm({ ...form, fin: e.target.value })}
          />
          <input
            type="email"
            placeholder="Email"
            className="w-full border rounded p-2"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="tel"
            placeholder="Phone number"
            className="w-full border rounded p-2"
            value={form.telephone}
            onChange={(e) => setForm({ ...form, telephone: e.target.value })}
            required
          />

          {status === "error" && <p className="text-red-600">{message}</p>}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          >
            Confirm the appointment
          </button>
        </form>
      )}
    </div>
  );
}
